import type { WiwState } from '@/store';

export const getTosAckRequired = (state: WiwState) => state.data.termsOfService.tosAckRequired;
